<template>

    <div class="cursor-pointer">
        <segment-visualizer
            :help="help"
            :json-query="jsonQuery"
            :json-filter="jsonFilter"
            :show-business-rules="false"
            :disable-sub-panel-filtering="true"
            :definition-builder-open="definitionBuilderOpen"
            :title="name"
            :title-color="color"
            :title-icon="icon"
            :empty-segment-warning="emptyPersonaWarning"
            :selectable-segment="false"
            @change="updated"
        ></segment-visualizer>
    </div>
</template>

<script>

import SegmentVisualizer from '../../Segments/components/SegmentVisualizer';

export default {

    components: {
        SegmentVisualizer
    },

    props: {
        jsonQuery: {
            type: Object | null,
            required: true,
        },
        jsonFilter: {
            type: Object | null,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true
        },
        emptyPersonaWarning: {
            type: String,
            required: true
        },
        help: {
            type: String,
            required: false,
            default: null,
        }
    },

    data() {
        return {
            definitionBuilderOpen: false,
        }
    },

    methods: {

        updated(segment) {
            this.$emit('change', segment);
        },
    }
}
</script>
